export type ConsentCategories = {
  necessary: true; // mereu activ
  analytics: boolean;
  marketing: boolean;
};

export type ConsentRecord = {
  categories: ConsentCategories;
  timestamp: string;
  version: number;
};

const STORAGE_KEY = "nexafx_cookie_consent";
const CURRENT_VERSION = 1;

export function getConsent(): ConsentRecord | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ConsentRecord;
    if (parsed.version !== CURRENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent(categories: Omit<ConsentCategories, "necessary">) {
  const record: ConsentRecord = {
    categories: { necessary: true, ...categories },
    timestamp: new Date().toISOString(),
    version: CURRENT_VERSION,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: record }));
}

export function acceptAll() {
  saveConsent({ analytics: true, marketing: true });
}

export function rejectAll() {
  saveConsent({ analytics: false, marketing: false });
}

export function clearConsent() {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: null }));
}

export function hasConsent(category: keyof ConsentCategories): boolean {
  const c = getConsent();
  if (!c) return false;
  return !!c.categories[category];
}